// GetAllScrutinyNotes
export const GET_ALL_SCRUTINY_NOTES = "GET_ALL_SCRUTINY_NOTES"
export const GET_ALL_SCRUTINY_NOTES_SUCCESS = "GET_ALL_SCRUTINY_NOTES_SUCCESS"
export const GET_ALL_SCRUTINY_NOTES_ERROR = "GET_ALL_SCRUTINY_NOTES_ERROR"

// GetAllScrutinyNotesType
export const GET_ALL_SCRUTINY_NOTES_TYPE = "GET_ALL_SCRUTINY_NOTES_TYPE"
export const GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS = "GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS"
export const GET_ALL_SCRUTINY_NOTES_TYPE_ERROR = "GET_ALL_SCRUTINY_NOTES_TYPE_ERROR"

// update scrutiny status
export const UPDATE_SCRUTINY_STATUS = "UPDATE_SCRUTINY_STATUS"
export const UPDATE_SCRUTINY_STATUS_SUCCESS = "UPDATE_SCRUTINY_STATUS_SUCCESS"
export const UPDATE_SCRUTINY_STATUS_ERROR = "UPDATE_SCRUTINY_STATUS_ERROR"